import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import PageHero from "../components/PageHero";
import LocationSwitcher from "../components/LocationSwitcher";
import LocationAtlas from "../components/LocationAtlas";
import Contact from "../components/Contact";
import { locations } from "../data/siteData";
import "./LocationsPage.css";

export default function LocationsPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const initial = locations.find((l) => l.slug === slug) || locations[0];
  const [activeId, setActiveId] = useState(initial.id);

  useEffect(() => {
    const found = locations.find((l) => l.slug === slug);
    if (found) setActiveId(found.id);
  }, [slug]);

  const active = locations.find((l) => l.id === activeId);

  const handleChange = (id) => {
    setActiveId(id);
    const loc = locations.find((l) => l.id === id);
    navigate(`/locations/${loc.slug}`, { replace: true });
  };

  if (!slug) {
    return (
      <>
        <PageHero
          eyebrow="Our Locations"
          title={["TWO CITIES.", "ONE STANDARD", "OF ENERGY."]}
          subtitle="Explore either Selectra Solar location to see local teams, contact details and coverage areas."
        />
        <LocationAtlas />
      </>
    );
  }

  return (
    <>
      <section className="location-detail">
        <div className="location-detail__glow" aria-hidden="true" />
        <div className="container location-detail__inner">
          <span className="eyebrow">Location {active.code}</span>
          <h1 className="location-detail__title">{active.city}</h1>

          <LocationSwitcher activeId={activeId} onChange={handleChange} />

          <AnimatePresence mode="wait">
            <motion.div
              key={active.id}
              className="location-detail__grid"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="location-detail__image" />
              <div className="location-detail__info">
                <p className="location-detail__description">
                  {active.description}
                </p>
                <dl>
                  <div>
                    <dt>Address</dt>
                    <dd>{active.address}</dd>
                  </div>
                  <div>
                    <dt>Phone</dt>
                    <dd>{active.phone}</dd>
                  </div>
                  <div>
                    <dt>Email</dt>
                    <dd>{active.email}</dd>
                  </div>
                  <div>
                    <dt>Hours</dt>
                    <dd>{active.hours}</dd>
                  </div>
                </dl>
                <div className="location-detail__stat">
                  <span className="glow-text">{active.stat.value}</span>
                  <span>{active.stat.label}</span>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>
      <Contact />
    </>
  );
}
